/** @format */
import React from 'react';

import { SearchFacet } from '@toucan/common/services/search/constants';

import { SearchFilterMenuOptionList } from '@toucan/client/features/search/components/model-search-results/components/filters/components/option-list';
import { SearchFilterMenuPriceOptions } from '@toucan/client/features/search/components/model-search-results/components/filters/components/price-options';
import {
    Filter,
    FilterOption,
} from '@toucan/client/features/search/components/model-search-results/types';

export const SearchFilter = ({
    'data-testid': dataTestId,
    filter,
    selectedItems,
    onUpdate,
    isLoading,
}: {
    'data-testid'?: string;
    filter: Filter;
    selectedItems: FilterOption[];
    onUpdate: (filter: Filter, items: FilterOption[]) => void;
    isLoading: boolean;
}) => {
    function setSelectedItems(items: FilterOption[]) {
        onUpdate(filter, items);
    }

    function renderFilterOptions() {
        if (filter.id === SearchFacet.productPrice) {
            return (
                <SearchFilterMenuPriceOptions
                    isLoading={isLoading}
                    filter={filter}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    autoFocusPriceGroup={false}
                />
            );
        }

        return (
            <SearchFilterMenuOptionList
                isLoading={isLoading}
                filter={filter}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
            />
        );
    }

    return <div data-testid={dataTestId}>{renderFilterOptions()}</div>;
};
